import type { SVGProps } from 'react';

const SvgGlobe02 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2C12 2 8 6 8 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M21 15H3" stroke="currentColor" strokeWidth="1.5" />
    <path d="M21 9H3" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
export default SvgGlobe02;
